
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { updatePassword } from '../services/api';

// for all page of dashboard
import WebNav from '../components/WebNav';
import Sidebar from '../components/Sidebar';
import '../styles/Style.css';
//** */

const Password = () => {
  // Check if user is logged in
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    document.body.classList.add('loged-body');

    return () => {
      document.body.classList.remove('loged-body');
    };
  }, []);

  // State variables for password fields
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // State for showing password visibility
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Handle input changes
  const handleOldPasswordChange = (e) => setOldPassword(e.target.value);
  const handleNewPasswordChange = (e) => setNewPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);

  // Toggle password visibility
  const toggleOldPasswordVisibility = () => setShowOldPassword(!showOldPassword);
  const toggleNewPasswordVisibility = () => setShowNewPassword(!showNewPassword);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

  const validatePasswords = () => {
    if (newPassword !== confirmPassword) {
      setErrorMessage('New password and confirm password must match.');
      return false;
    }
    if (newPassword.length < 6) {
      setErrorMessage('Password must be at least 6 characters.');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    // Validate passwords
    if (!validatePasswords()) {
      return;
    }
    const updatePasswordFunction = async () => {
      try {
        const data = await updatePassword(oldPassword,newPassword,confirmPassword);
        console.log('data',data);
        setSuccessMessage('Password updated Successfully..!');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setTimeout(() => {
            setSuccessMessage('');
        }, 10000);
      } catch (error) {
        setErrorMessage(error.response.data.error);
        setTimeout(() => {
          setErrorMessage('');
        }, 10000);
      }
    }
    
    updatePasswordFunction();

  };


  return (
    <>
      <Sidebar />
      <WebNav />
      <div className='d-body login-body'>
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={8}>
                <Card>
                    <Card.Header className="text-center">
                    <h2>Change Password</h2>
                    </Card.Header>
                    <Card.Body>
                    {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                    {successMessage && <Alert variant="success">{successMessage}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="oldPassword">
                        <Form.Label>Old Password</Form.Label>
                        <div className="position-relative">
                            <Form.Control
                            type={showOldPassword ? 'text' : 'password'}
                            value={oldPassword}
                            onChange={handleOldPasswordChange}
                            required
                            />
                            <FontAwesomeIcon
                            icon={showOldPassword ? faEye : faEyeSlash}
                            className="position-absolute"
                            style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}
                            onClick={toggleOldPasswordVisibility}
                            />
                        </div>
                        </Form.Group>

                        <Form.Group controlId="newPassword" className="mt-4">
                        <Form.Label>New Password</Form.Label>
                        <div className="position-relative">
                            <Form.Control
                            type={showNewPassword ? 'text' : 'password'}
                            value={newPassword}
                            onChange={handleNewPasswordChange}
                            required
                            />
                            <FontAwesomeIcon
                            icon={showNewPassword ? faEye : faEyeSlash}
                            className="position-absolute"
                            style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}
                            onClick={toggleNewPasswordVisibility}
                            />
                        </div>
                        </Form.Group>

                        <Form.Group controlId="confirmPassword" className="mt-4">
                        <Form.Label>Confirm New Password</Form.Label>
                        <div className="position-relative">
                            <Form.Control
                            type={showConfirmPassword ? 'text' : 'password'}
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                            required
                            />
                            <FontAwesomeIcon
                            icon={showConfirmPassword ? faEye : faEyeSlash}
                            className="position-absolute"
                            style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}
                            onClick={toggleConfirmPasswordVisibility}
                            />
                        </div>
                        </Form.Group>

                        <Button variant="success" type="submit" className="mt-4 w-100">
                        Update Password
                        </Button>
                    </Form>
                    </Card.Body>
                </Card>
                </Col>
            </Row>

        </Container>
      </div>
    </>
  )
}

export default Password